export default "/images/vendor/flag-icon-css/flags/1x1/zm.svg?a303f51a36999e85ed3baa54fef73a7a";